import Vue from "vue";
import Vuex from "vuex";
import users from "./users";
import dashboard from "./Dashboard";
import broker from "./broker";
import realtor from "./realtor";
import Template from "./Template";
import Role from "./Role";
import Task from "./Task";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    users,
    dashboard,
    broker,
    realtor,
    Template,
    Role,
    Task,
  },
});
